import {
  buildSupabaseAuthStorageKey,
  createSupabaseBrowserCookieStorage,
} from '@/lib/auth/supabaseCookieStorage'

const rawSupabaseUrl = import.meta.env.VITE_SUPABASE_URL

export const SUPABASE_AUTH_STORAGE_KEY = buildSupabaseAuthStorageKey(rawSupabaseUrl)

export function createSupabaseAuthStorage() {
  return createSupabaseBrowserCookieStorage(SUPABASE_AUTH_STORAGE_KEY)
}
